import qs from 'query-string';

import { ALBUM_PRICE_MODE } from '../../../../../../../constants/albums';

/**
 * Determines whether an AlbumFolder is "parent pay".
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {boolean}
 */
export const isAlbumFolderParentPay = albumFolder => {
  if (!albumFolder) {
    return false;
  }

  const hasPrice = albumFolder.price?.value > 0 && !albumFolder.is_demo;
  const isPpa =
    !!albumFolder.album_price_mode &&
    albumFolder.album_price_mode === ALBUM_PRICE_MODE.PPA_ONLY;

  return hasPrice || isPpa;
};

/**
 * @param {Object} options The options.
 * @param {string} options.url The URL to decorate.
 * @param {string} options.campaign The UTM campaign string.
 * @param {string} options.source The UTM source string.
 * @param {string} options.medium The UTM medium string.
 * @param {string} options.content The UTM content string.
 * @returns {string}
 */
export const getUtmParamsUrlDecorator = ({
  url,
  campaign,
  source,
  medium,
  content,
}) => {
  if (!url) {
    return '';
  }

  const urlObject = new URL(url);
  const parsed = qs.parse(urlObject.search);

  const params = qs.stringify({
    ...parsed,
    utm_campaign: campaign,
    utm_source: source,
    utm_medium: medium,
    utm_content: content,
  });

  return `${url.split('?')[0]}?${params}`;
};

/**
 * @param {Object} options The options.
 * @param {string} options.url The URL to decorate.
 * @param {Object} options.albumFolder The AlbumFolder.
 * @returns {string}
 */
export const getUtmParamsForQrCodeUrl = ({ url, albumFolder }) => {
  if (!albumFolder) {
    return url ?? '';
  }

  const { account } = albumFolder;

  return getUtmParamsUrlDecorator({
    url,
    medium: 'qr-code',
    campaign: albumFolder.id,
    source:
      account?.organization_name ??
      account?.username ??
      account?.name ??
      account?.id,
    content: albumFolder.album_subtype ?? 'CUSTOM',
  });
};
